import { render, staticRenderFns } from "./superdocument-audit.vue?vue&type=template&id=4f521c32&scoped=true"
import script from "./superdocument-audit.vue?vue&type=script&lang=js"
export * from "./superdocument-audit.vue?vue&type=script&lang=js"
import style0 from "./superdocument-audit.vue?vue&type=style&index=0&id=4f521c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f521c32",
  null
  
)

export default component.exports